module.exports = __webpack_public_path__ + "img/logo-imprimax2.c443e269.svg";